import React, { useEffect, useState } from 'react';
import { includes, isEmpty } from 'lodash';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { EventsSection } from './styles/EventsSection.styled';
import { SectionHeadline } from './styles/SectionHeadline.styled';
import { Link } from './styles/Link.styled';
import { Container } from './styles/Container.styled';
import {
  EventsSlikSlider,
  EventImage,
  EventSliderCard,
  EventCardHeader,
  Data,
  Title,
  Type,
  EventSliderLink,
} from './styles/EventSliderCard.styled';
import { DWTCContext } from '../utils/context';
import Sprites from './Sprites';
import { convertMonthToAr, startEndDateToString } from '../helpers/date-convert';
import Events from '../services/Events';
import { getTranslationByKey } from '../helpers/translation-helper';

export default function EventsSlider({ data, id, dir }) {
  const { cssClass, translations } = React.useContext(DWTCContext);

  const getTheme = () => {
    if (includes(cssClass, 'free-zone')) return 'red';
    if (includes(cssClass, 'real-estate')) return 'green';
    return 'secondary';
  };

  const { title, parentLink } = data;

  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: true,
    dots: true,
    arrows: true,
    initialSlide: 0,
    centerMode: true,
    speed: 800,
    useCSS: true,
    easing: 'linear',
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '280px',
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '150px',
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '80px',
        },
      },
      {
        breakpoint: 575,
        settings: {
          arrows: false,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '60px',
        },
      },
      {
        breakpoint: 430,
        settings: {
          arrows: false,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '22px',
        },
      },
    ],
  };

  const getDubaiTime = (date) => {
    const dubaiDate2 = new Date(date).toLocaleString('en-US', { timeZone: 'Asia/Dubai' });
    return new Date(dubaiDate2);
  };

  const events = new Events();
  const eventsFiltered = events.get(dir === 'rtl' ? 'ar' : 'en');

  const [eventsList, setEventsList] = useState(eventsFiltered);
  const dubaiDate = new Date();
  const currDate = getDubaiTime(dubaiDate);
  currDate.setHours(0, 0, 0, 0);

  useEffect(() => {
    let filteredEvents = eventsList;
    filteredEvents = eventsList.filter((event) => getDubaiTime(event.endDate) >= currDate);
    filteredEvents.sort((a, b) => {
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
      return 0;
    });
    filteredEvents.sort((a, b) => {
      const durationA = (getDubaiTime(a.endDate) - getDubaiTime(a.startDate)) / 1000 / 60 / 60 / 24;
      const durationB = (getDubaiTime(b.endDate) - getDubaiTime(b.startDate)) / 1000 / 60 / 60 / 24;
      if (durationA < durationB) return 1;
      if (durationA > durationB) return -1;
      return 0;
    });
    filteredEvents.sort((a, b) => getDubaiTime(a.startDate) - getDubaiTime(b.startDate));
    setEventsList(filteredEvents.length > 12 ? [...filteredEvents.slice(0, 12)] : filteredEvents);
  }, []);

  const viewAll = dir === 'ltr' ? 'VIEW ALL' : 'عرض الكل';
  const isArabic = dir === 'rtl';

  return (
    <EventsSection id={id} dir={dir}>
      <Container className="zeropadding_responsive">
        <SectionHeadline className="section_caption event_slider_cap" dir={dir}>
          <h2 dir={dir}>{title}</h2>
          <Link
            color={getTheme()}
            to={isEmpty(parentLink) ? '#0' : parentLink.url}
            className="home_link view_all"
            dir={dir}
          >
            <p dir={dir}>{viewAll}</p>
            <Sprites name="arrow" className="arrow" />
          </Link>
        </SectionHeadline>
        <EventsSlikSlider className="margin_slider_sv" dir={dir}>
          <Slider {...settings}>
            {[...eventsList.slice(1), eventsList[0]].map(
              (event, index) =>
                event &&
                index < 12 && (
                  <EventSliderLink to={event.url || '#0'} key={event.id}>
                    <EventSliderCard data-slick-index={index} aria-hidden="false" dir={dir}>
                      <EventCardHeader>
                        <Data dir={dir}>
                          {isArabic
                            ? convertMonthToAr(startEndDateToString(event.startDate, event.endDate))
                            : startEndDateToString(event.startDate, event.endDate)}
                        </Data>
                        <Title dir={dir}>{event.title}</Title>
                        <Type dir={dir}>
                          {getTranslationByKey(translations, event.eventSectors[0])}
                        </Type>
                      </EventCardHeader>
                      <EventImage dir={dir}>
                        {isEmpty(event.featuredImage) ? null : (
                          <LazyLoadImage
                            height={218}
                            width="100%"
                            placeholderSrc={
                              event.featuredImage.url
                                ? `${event.featuredImage.url}?width=50&quality=50`
                                : null
                            }
                            src={event.featuredImage.url}
                            effect="blur"
                            alt={event.title}
                          />
                        )}
                      </EventImage>
                    </EventSliderCard>
                  </EventSliderLink>
                ),
            )}
          </Slider>
        </EventsSlikSlider>
      </Container>
    </EventsSection>
  );
}
